export class UploadFile {

    file: File;
    directoryNameList: string[];

    constructor(file: File, directoryNameList: string[]) {
        this.file = file;
        if (directoryNameList.length > 0) {
            this.directoryNameList = directoryNameList;
        } else {
            this.directoryNameList = [];
        }
    }

}